import "./ProgressSection.css"

import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function ProgressBar({
  value,
  nextBadgeName,
  currentProgress,
}: {
  value: number
  nextBadgeName: string
  currentProgress: number
}) {
  const { t } = useTranslation()
  return (
    <div className="progress-section w-100">
      <div className="progress-bar" style={{ width: `${value}%` }}>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="progress-tooltip">
              {nextBadgeName
                ? `${currentProgress}%`
                : t("homePage.leaderboard.progress.reachedHighestBadge")}
            </Tooltip>
          }
        >
          <span className="progress-dot" />
        </OverlayTrigger>
      </div>
    </div>
  )
}
